import React from 'react';
 
export const ModalContent = ({ children,styles, clases = "" }) => {
    return (
        <div style={styles} className={`${clases} modal-content   rounded-md shadow-2xl   ease-in`}>
            {children}
        </div>
    )
}

export const ModalHeader = ({title, onClose,children, iconClose, closeStyles}) => {
    return ( 
        <div className='header-modal flex items-center '>
            <div className='modal-title flex-1'>{title}</div>
            {iconClose ? <div className='close-modal' style={closeStyles} onClick={() => onClose()}><img src='/icons/close-icon.svg' /></div> : null}
            {children} 
        </div> 
    )
}

export const ModalBody = ({title, onClose,children, mediaQuerys = "", styles={}}) =>{
    return (
        <div className={`${mediaQuerys} modal-body     `}  style={styles}> 
            {children}
        </div>
    )
}
export const ModalFooter = ({title, onClose,children, clases = ""}) =>{
    return (
        <div className={`${clases} modal-footer  w-full `}> 
            {children}
        </div>
    )
}
const ModalVw = React.forwardRef(({style={}, className="", children, visible, id }, ref) => {

    return (

        <div ref={ref} style={style} id={id} className={`${className} modal-vw ease-in ${visible ? 'open-modal' : 'close-modal'}`}>
            {children}
        </div>
    )
})

export default ModalVw;